import React, { Component, useState, useEffect } from 'react';
import { Card, CardImg, CardText, CardBody, CardTitle, CardSubtitle, Button, Nav, NavItem, TabContent, TabPane, NavLink, Row } from 'reactstrap';
import LoginModal from './partials/LoginModal';
import HeaderComponent from './partials/HeaderComponent';
import FooterComponent from './partials/FooterComponent';
import HeaderCarousel from './partials/HeaderCarousel';
import { withRouter,Redirect } from 'react-router-dom';
import { connect } from 'react-redux';
import { LOGIN, LOGOUT } from '../Pages/ReduxStore/slices/authSlice';
import "./css/contests.css";

const Img64 = ({ data }) => {
  return (<CardImg top width="100%" src={`data:image/png;base64, ${data.slice(2, -1)}`} />);
};
function RenderCards(props) {
  const dateFormat = new Intl.DateTimeFormat('en-US', { year: 'numeric', month: 'short', day: '2-digit' });
  return (
    <div className="">
      <Card>
        <a className="contest-card-link" onClick={() => { props.onClick(props.contest.contest_id) }}>
          <Img64 data={props.contest.cont_image} />
          <CardBody>
            <CardTitle tag="h5" className="contest-card-title">{props.contest.contest_name}</CardTitle>
            <br />
            <div className="row">
              <CardSubtitle tag="h6" className="mb-2 text-muted col-5"><b>Date :</b ><br />{dateFormat.format(new Date(props.contest.start_time))}</CardSubtitle>
              <CardSubtitle tag="h6" className="mb-2 text-muted col-3 px-0"><b>Starts :</b ><br />{new Date(props.contest.start_time).toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' })}</CardSubtitle>
              <CardSubtitle tag="h6" className="mb-2 text-muted col-4"><b>Ends :</b><br />{new Date(props.contest.end_time).toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' })}</CardSubtitle>
            </div>
          </CardBody>
        </a>
      </Card>
    </div>
  );
}

class Contests extends Component {
  constructor(props) {
    super(props);
    this.state = {
      activeTab: '2',
      isModalOpen: false
    }
    this.toggleActiveTab = this.toggleActiveTab.bind(this);
    this.toggleModal = this.toggleModal.bind(this);
    this.goToContestProblems = this.goToContestProblems.bind(this);
  }
  toggleModal() { this.setState({ isModalOpen: !this.state.isModalOpen, activeTab: "1" }); }
  toggleActiveTab = (tab) => { if (this.state.activeTab !== tab) { this.setState({ activeTab: tab }); } };

  goToContestProblems = (contest_id) => {
    if (this.props.isAuthenticated) {
      this.props.history.push(`/contests/${contest_id}`);
    }
    else {
      this.toggleModal();
    }
  }
  contestRender = (contestList) => contestList.map((contest) => {
    return (
      <div key={contest.contest_id} className="col-12 col-md-4 mt-5">
        <RenderCards contest={contest} onClick={this.goToContestProblems} />
      </div>
    );
  });
  render() {
    const Default = <h4 className="w-100 text-center pt-5 pb-4 not-available">Oops!! No Contests available in this section please try other sections.</h4>;
    const Live = () => (this.props.ongoing.length===0) ? Default  : this.contestRender(this.props.ongoing);
    const Upcoming = () => (this.props.upcoming.length === 0) ? Default :  this.contestRender(this.props.upcoming);
    const Previous = () => (this.props.past.length === 0) ? Default :  this.contestRender(this.props.past);
    try {
      return (
        <>
          <HeaderComponent />
          <LoginModal toggleModal={this.toggleModal} isModalOpen={this.state.isModalOpen} />
          <div className="contests-page-wrapper">
            <div className="head-carousel pt-4">
            <HeaderCarousel/>
            </div>
            <br />
            <div className="container px-3 mb-5">
              <div className="contest-container">
                <div className="d-flex justify-content-center">
                  <Nav tabs className="row w-100 d-flex align-items-center justify-content-center">
                    <NavItem className="col-4 text-center px-0 nav-tab-link">
                      <NavLink
                        className={this.state.activeTab == '1' ? 'active' : ''}
                        onClick={() => { this.toggleActiveTab('1'); }}>
                        <span class="d-none d-sm-block">Live Contests</span>
                        <span class="d-block d-sm-none">Live</span>
                      </NavLink>
                    </NavItem>
                    <NavItem className="col-4 text-center px-0 nav-tab-link">
                      <NavLink
                        className={this.state.activeTab == '2' ? 'active' : ''}
                        onClick={() => { this.toggleActiveTab('2'); }}>
                        <span class="d-none d-sm-block">Upcoming Contests</span>
                        <span class="d-block d-sm-none">Upcoming</span>
                      </NavLink>
                    </NavItem>
                    <NavItem className="col-4 text-center px-0 nav-tab-link">
                      <NavLink
                        className={this.state.activeTab == '3' ? 'active' : ''}
                        onClick={() => { this.toggleActiveTab('3'); }}>
                        <span class="d-none d-sm-block">Past Contests</span>
                        <span class="d-block d-sm-none">Past</span>
                      </NavLink>
                    </NavItem>
                  </Nav>
                </div>
                <TabContent className="container px-md-4 pb-4" activeTab={this.state.activeTab}>
                  <TabPane tabId="1">
                    <Row>
                      <Live />
                    </Row>
                  </TabPane>
                  <TabPane tabId="2">
                    <Row>
                      <Upcoming />
                    </Row>
                  </TabPane>
                  <TabPane tabId="3">
                    <Row>
                      <Previous />
                    </Row>
                  </TabPane>
                </TabContent>
              </div>
            </div>
          </div>
          <FooterComponent />
        </>
      );
    }
    catch {
      return (
        <Redirect to="/404Page" />
      );
    }
  }
}
const mapStateToProps = state => {
  return {
    isAuthenticated: state.auth.isAuthenticated,
    username: state.auth.username
  }
}

const mapDispatchToProps = dispatch => {
  return {
    reduxLogin: (username) => dispatch(LOGIN(username)),
    reduxLogout: () => dispatch(LOGOUT())
  }
}
export default connect(mapStateToProps, mapDispatchToProps)(withRouter(Contests));


